import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './typeahead-overlay.scss';

const BrandPromiseOverlay = ({ isTypeaheadOpen }) => {
  const transparentOverlayClasses = classNames(styles.bpTransparentOverlay, {
    [styles.bpTransparentOverlay__hidden]: !isTypeaheadOpen,
  });
  const bpOverlayClasses = classNames(styles.bpOverlay, {
    [styles.bpOverlay__hidden]: !isTypeaheadOpen,
  });
  return (
    <>
      <div
        className={transparentOverlayClasses}
        data-testid="search-transparent-overlay"
      />
      <div className={bpOverlayClasses} data-testid="search-bp-overlay" />
    </>
  );
};

BrandPromiseOverlay.propTypes = {
  isTypeaheadOpen: PropTypes.bool.isRequired,
};

export default BrandPromiseOverlay;
